import BtnSecondaryM from "../Buttons/BtnSecondaryM";
import PropTypes from "prop-types";

const NoteItem = ({
  noteItem,
  openPopup,
  buttonCTA,
  descriptionClassName = "",
  truncateTitle = false,
  truncateDescription = false,
}) => {
  const title =
    truncateTitle && noteItem.note_title.length > 50
      ? noteItem.note_title.slice(0, 50) + "..."
      : noteItem.note_title;

  const description =
    truncateDescription && noteItem.note_description.length > 150
      ? noteItem.note_description.slice(0, 150) + "..."
      : noteItem.note_description;

  return (
    <div className="relative w-full h-full flex flex-col gap-2.5 justify-between bg-white rounded-lg p-4 card-base-border shadow-xs">
      {/* <div className="absolute top-[-1vh] right-5 z-1">
        <GoPaperclip size="25px" />
      </div> */}

      <div className="flex flex-col gap-5 mb-auto">
        <div className="flex justify-end text-sm">
          <p className="">
            {/* {DateTime.fromISO(noteItem.note_date).toLocaleString(DateTime.DATE_MED)} */}
            {new Date(noteItem.note_date).toLocaleDateString()}
          </p>
        </div>
        <div className="flex flex-col gap-2">
          <p className="text-base">{title}</p>

          <div className={`note-description-container ${descriptionClassName}`}>
            <p className="text-sm">{description}</p>
          </div>
        </div>
      </div>

      {buttonCTA && openPopup && (
        <div className="flex justify-center">
          <BtnSecondaryM buttonCTA={buttonCTA} onClickLink={openPopup} />
        </div>
      )}
    </div>
  );
};

NoteItem.propTypes = {
  noteItem: PropTypes.object.isRequired,
  openPopup: PropTypes.func.isRequired,
  buttonCTA: PropTypes.string.isRequired,
  descriptionClassName: PropTypes.string,
  truncateTitle: PropTypes.bool,
  truncateDescription: PropTypes.bool,
};

export default NoteItem;
